import type { IconData } from '@stacksjs/iconify-core'

export const viewModule: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64v384h480V64Zm448 176H352V96h112Zm-272 0V96h128v144Zm128 32v144H192V272ZM160 96v144H48V96ZM48 272h112v144H48Zm304 144V272h112v144Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default viewModule
